import React from 'react'

import { useCountdownFSBonusStore } from '@stores'
import { BSModalButton } from '@components'
import { useTranslation } from '@amusnet/translations/react'
import {
    BonusSystemState,
    Bonus,
    BonusesPlayNowMessage,
    GameUIMessageType,
    BonusesPlayLaterMessage,
} from 'game-ui-types'

interface CFSMainButtonsProps {
    bonus?: Bonus
}

const CFSMainButtons: React.FC<CFSMainButtonsProps> = ({ bonus }: CFSMainButtonsProps) => {
    const bonusSystemState = useCountdownFSBonusStore((state) => state.bonusSystemState)
    const setBonusSystemState = useCountdownFSBonusStore((state) => state.setBonusSystemState)

    const { t } = useTranslation()

    const primaryButtonText = t('gameui.playNow')
    const secondaryButtonText = t('gameui.playLater')

    const isInSingleBonusState = bonusSystemState === BonusSystemState.SINGLE_BONUS_INITIAL

    const playNowHandler = () => {
        if (isInSingleBonusState) {
            if (!bonus) {
                return
            }

            const message: BonusesPlayNowMessage = {
                type: GameUIMessageType.BONUSES_PLAY_NOW,
                payload: { bonusIds: [bonus.id] },
            }

            window.postMessage(message)
            setBonusSystemState(BonusSystemState.IN_PLAY)
        }
    }

    const playLaterHandler = () => {
        if (isInSingleBonusState) {
            if (!bonus) {
                return
            }

            const message: BonusesPlayLaterMessage = {
                type: GameUIMessageType.BONUSES_PLAY_LATER,
                payload: { bonusIds: [bonus.id] },
            }

            window.postMessage(message)
            setBonusSystemState(BonusSystemState.INACTIVE)
        }
    }

    return (
        <div className="flex justify-center gap-[20px] w-full px-[77px] pt-[24px] pb-[24px]">
            {bonus?.playLater && (
                <BSModalButton
                    id={secondaryButtonText.toLowerCase().replace(/\s+/g, '-')}
                    text={secondaryButtonText}
                    isPrimary={false}
                    onClick={playLaterHandler}
                />
            )}
            <BSModalButton
                id={primaryButtonText.toLowerCase().replace(/\s+/g, '-')}
                text={primaryButtonText}
                onClick={playNowHandler}
            />
        </div>
    )
}

export default CFSMainButtons
